import * as actions from '../../actions/task/editTaskActions'

export const initialState = {
    editTask: {},
    loading: false,
    hasErrors: false,
    editingTask: false,
    editingLoading: false,
    editingHasErrors: false,
    editingSuccessToaster: false,
    editingErrorToaster: false,
}

export default function editTaskReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_EDIT_TASK:
            return { ...state, loading: true }
        case actions.GET_EDIT_TASK_SUCCESS:
            return { ...state, editTask: action.payload, loading: false, hasErrors: false, editingTask: true }
        case actions.GET_EDIT_TASK_FAILURE:
            return { ...state, loading: false, hasErrors: true, editingTask: false }
        case actions.CANCEL_EDIT_TASK:
            return { ...state, editTask: {}, loading: false, hasErrors: false, editingTask: false, editingHasErrors: false, editingSuccessToaster: false, editingErrorToaster: false }
            
        // Update task
        case actions.UPDATE_TASK_INIT:
            return { ...state, editingLoading: true }
        case actions.UPDATE_TASK_SUCCESS:
            return { ...state, editTask: {}, editingSuccessToaster: true, editingLoading: false, editingHasErrors: false, editingTask: false }
        case actions.UPDATE_CONTINUE_TASK_SUCCESS:
            return { ...state, editTask: action.payload, editingLoading: false, editingHasErrors: false, editingTask: true, editingSuccessToaster: false }
        case actions.UPDATE_TASK_FAILURE:
            return { ...state, editingLoading: false, editingHasErrors: true, editingTask: false, editingErrorToaster: true }
        case actions.SET_EDIT_INITIAL_STATE:
            return { ...state, hasErrors: false, editingHasErrors: false, editingSuccessToaster: false, editingErrorToaster: false,}

        default:
            return state
    }
}